<template>
  <article>
    <UserAvatar
      :pUserId="creatorId"
      p-font-size="1.2rem"
      p-line-height="2.5rem"
      pSize="35px">

    </UserAvatar>
    <a v-if="!isSharedFromAnotherRally"  v-on:click="$emit('perform', 'openContent', content)" class="title">{{
      content.attributes.title
    }}</a>
    <div v-if="isSharedFromAnotherRally"  class="title">
      * SHARED by {{sharedByName}} {{
      content.attributes.title
    }}</div>
    <div class="author-name">
      {{ byLine }}<span v-if="creatorBlocked"> (Blocked User)</span>
    </div>
    <div class="created-at is-scheduled" v-if="isScheduled">
      scheduled for {{ formattedStartDate }}
    </div>
    <div class="created-at" v-else>
      {{ when }} : seen by {{ views }}
    </div>
    <div v-if="creatorBlocked" class="body">
      <BlockedContentNotice :user-id="creatorId" what="the full post" />
    </div>
    <div v-else class="body">
      <div class="message-content" v-html="content.attributes.body"/>
      <ContentAttachments v-on:perform="perform" :readOnly="true" :content="content" :rallyId="parseInt(this.rallyId)" :channelId="parseInt(this.channelId)" :channel="this.channel" />
    </div>
     <ContentPin :content="content"/>
     <ContentElipsisMenu :content="content" :rallyId="this.rallyId" :channelId="this.channelId" contentType="MessageWall" :canPin="isEditable" canShare="true"/>
     <Comments
      :shareId="content.relationships['context-share'].data.id"
      :avatarFile="content.attributes['creator-avatar']"
      :channelId="channelId"
      :rallyId="this.rallyId"
      v-if="content.relationships && content.relationships['context-share'] && currentChannel.attributes['allow-comments']"
    />
  </article>
</template>

<script>

import moment from "moment-timezone";
import { mapState, mapActions, mapGetters } from "vuex";
import { router } from "../../../common";
import { HB_LOGGING } from "../../../common";
import ContentMixin from "../../ContentMixin";
import BlockedContentNotice from "../../BlockedContentNotice.vue";
import Vue from 'vue';
import { globalVueRef } from "../../../main.js";

export default {
  name: "WallMessageListed",
  props: ["id", "channel", "content", "rally"],
  components: { BlockedContentNotice },
  mixins: [ContentMixin],
  data() {
    return {
      page: 1,
      show_create: false,
      showElipsis: false,
      polling_int: null,
      newMessage: {
        title: null,
        body: null
      }
    };
  },
  computed: {
    ...mapState("user", ["status", "user", "usersById"]),
    ...mapGetters("blockedUsers", ["isUserBlocked"]),
    creatorBlocked() {
      const cid = this.content?.attributes?.["creator-id"];
      return cid != null && parseInt(cid) !== parseInt(this.user?.user_id) && this.isUserBlocked(cid);
    },

    ...mapState("messages", ["allMessagesByRallyId"]),
    ...mapState("channels", ["channelsById"]),
    ...mapState("contents", ["allContentByContextTypeAndId", "contentById"]),
    ...mapState("navigation", ["currentChannel"]),
    ...mapState("shares", ["sharesByContentId"]),

    contentTitle(){
      return this.content.attributes.title
    },
    contentBody(){
      return this.content.attributes.body
    },
    creatorId() {
      return this.content.attributes['creator-id']
    },
    formattedStartDate() {
      return moment.utc(this.ownerShare.attributes['start-date']).format('MM/DD/YYYY');
    },
    isEditable() {
      return this.content.attributes['editable'] === true;
    },
    isScheduled() {
      const today = moment.utc().startOf('day');
      const startDate = moment.utc(this.ownerShare.attributes['start-date']).startOf('day');

      return startDate.isAfter(today);
    },
    rallyIdForUserAvatar(){
      if (this.ownerShare && this.ownerShare.attributes && this.ownerShare.attributes['context-rally-id']){
        return parseInt(this.ownerShare?.attributes['context-rally-id'])
      } else {
        return parseInt(this.rallyId)
      }
    },
  },
  created() {
    this.$route.params["pageNumber"] = 1;
    if (HB_LOGGING()){
      globalVueRef.$honeybadger.setContext({rally_id: this.rallyId}) 
    }
  },

  methods: {
    ...mapActions("messages", [
      "fetchAMessage",
      "createMessage",
    ]),
    /*userIsOwner(c){
      return (c && c.attributes && c.attributes["creator-id"] == this.user.user_id) 
    },*/
    hideActions() {
      this.showElipsis = false;
    },
    perform(method, params) {
      if ( this[method] ) {
        params ? this[method](params) : this[method]();
      } else {
        this.$emit('perform', method, params);
      }
    },
    formatDate(ds){
      return moment(ds).format("MM/DD/YYYY hh:mm a")
    },
    log(message) {
      this.$log.debug(message);
    }
  }
};
</script>

<style scoped>
/* Message Content Styling - Fix line spacing */
.message-content >>> p {
  margin: 0;
  padding: 0;
}

/* Add some spacing between paragraphs, but much less than default */
.message-content >>> p + p {
  margin-top: 16px;
}

/* Ensure first and last paragraphs don't have extra spacing */
.message-content >>> p:first-child {
  margin-top: 0;
}

.message-content >>> p:last-child {
  margin-bottom: 0;
}

/* Comments Section Styling */
.comments {
  margin-top: 20px;
  border-top: 1px solid #e9ecef;
  padding-top: 15px;
}

.comments-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px 15px;
  background-color: #f8f9fa;
  border-radius: 5px;
  margin-bottom: 10px;
  transition: background-color 0.2s;
  user-select: none;
}

.comments-toggle:hover {
  background-color: #e9ecef;
}

.comments-toggle i {
  margin-right: 8px;
  font-size: 14px;
  transition: transform 0.2s;
}

.comments-toggle span {
  font-size: 14px;
  color: #495057;
  font-weight: 500;
}

.load-more-comments {
  text-align: center;
  padding: 15px 0;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 15px;
}

.load-more-btn {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 20px;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.load-more-btn:hover {
  background-color: #f0f0f0;
  color: #0056b3;
}

.load-more-btn i {
  font-size: 12px;
}

/* Comment animations */
.content.listed.comment {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Ensure proper spacing between comments */
.content.listed.comment {
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.content.listed.comment:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
</style>